export const DOCUMENT_FILE_FORMAT = [
  [1, 'octets'],
  [1024, 'Ko'],
  [1024 * 1024, 'Mo'],
  [1024 * 1024 * 1024, 'Go'],
  [1024 * 1024 * 1024 * 1024, 'To'],
];
